<template>
<div>
<div class="foip-container" v-show="showFoip">
  <foip-statement @FOIPVisible="onFoipSubmit($event)" />
</div>
  <div class="container-reset-password" v-show="!showFoip">
    <b>Forgot Your Password?</b>
    <br>
    <br>
    <span>
      No problem.
      Please enter your email address below and then verify your security question.
    </span>
    <br>
    <div style="margin:10px;">
      <email-verification
        :page-title="title"
        ref="refEmailVerification"
        :erorrMessage = "erorrMessage"
        :isSubmitted = "isEmailSubmitted"
        @submit="onSubmitEmail"
      />
    </div>
    <div v-if="isEmailSubmitted">
      <security-code-verification
        ref="refSecurityCodeVerification"
        @isSecurityCodeSuccess="isSecurityCodeSuccess($event)" />
          <p>
            <span style="color: #0a3576; font-weight: 500;"> {{ userEmail }} </span>
            if you think you entered your email address incorrectly, please
            <ejs-button
                cssClass="e-link"
                v-on:click.native="tryAgain"
                style="padding: 3px">
                Try Again.
            </ejs-button>
          </p>
    </div>
  </div>
  </div>
</template>

<script>
import EmailVerification from '../components/email-verification.vue';
import SecurityCodeVerification from '../components/security-code-verification.vue';
import FoipStatement from '../../user-accounts/components/foip-statement.vue';

import { CONFIRM_USER_EMAIL } from '../store';

export default {
  name: 'ForgottenPassword',
  components: {
    EmailVerification,
    SecurityCodeVerification,
    FoipStatement,
  },
  data() {
    return {
      title: 'Reset Password',
      userEmail: null,
      isEmailSubmitted: false,
      emailSubmitErorrMessage: null,
      erorrMessage: null,
      nextPage: '/valid-resetpassword-token',
      showFoip: false,
    };
  },
  methods: {
    isSecurityCodeSuccess(event) {
      if (!event) return;

      const args = { ...event };
      if (args.isSuccess) {
        // According to the current logic, the next step and foip display is determined
        // based on the wordings from the security code sent out to the user :|
        if (args.code) {
          if (args.code.includes("PWDOWN")) {
            this.nextPage = '/valid-resetpassword-token-no-qustions';
          } else if (args.code.includes("PWDSCC")) {
            this.nextPage = '/valid-resetpassword-token-scc';
          }
        }

        if (args.code && args.code.includes("FOIP")) {
          this.showFoip = true;
          return;
        }

        this.$router.push(this.nextPage);
      }
    },
    onFoipSubmit(eventArgs) {
      if (eventArgs) { // event will emit boolean indiacating if foip is checked
        this.showFoip = false;
        this.$router.push(this.nextPage);
      } // no else: foip component only emits if user checked
    },
    async onSubmitEmail(email) {
      // this.$parent.notificationToasts.length = 0;
      const refEmailVerify = this.$refs.refEmailVerification;
      const userName = email;
      const rootURL = window.location.host;
      if (refEmailVerify.isEmailValid) {
        try {
          await this.$store.dispatch(CONFIRM_USER_EMAIL, { userName, rootURL, confirmType: 'resetPassword' });
          if (this.$store.getters.userDetails.status === 200) {
            this.$parent.notificationToasts.push({
              title: 'Thank you for your request!',
              content: `An email was sent to ${userName} with instructions to change your password.`,
              cssClass: 'e-toast-success',
              timeOut: 5000,
            });
            this.userEmail = email;
            this.isEmailSubmitted = true;
          } else if (this.$store.getters.userDetails) {
            switch (this.$store.getters.userDetails) {
              case 403:
                this.erorrMessage = 'Account exist with given email id.';
                break;
              case 404:
                this.erorrMessage = 'Your email is incorrect. Please try again.If you are experiencing any issues, please contact ASCA Tanks at ascatanks@safetycodes.ab.ca or by calling 1-888-413-0099.';
                break;
              case 423:
                this.erorrMessage = 'This account is Locked, you can contact ASCA Storage Tanks to un-lock your account at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks or by email at ascatanks@safetycodes.ab.ca';
                break;
              default:
                this.erorrMessage = 'Oops, Something went wrong. We are working on getting this fixed as soon as we can. You may be able to try again shortly. If you continue to experience this issue, you can contact ASCA Storage Tanks at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks or by email at ascatanks@safetycodes.ab.ca.';
            }
            if (this.erorrMessage) {
              this.$parent.notificationToasts.push({
                title: 'Error!',
                content: this.erorrMessage,
                cssClass: 'e-toast-danger',
                timeOut: 5000,
              });
            }
          }
        } catch (err) {
          if (err.Status === 408) {
            this.$parent.notificationToasts.push({
              title: 'Error!',
              content: 'Sorry, Something went wrong! Please try again later.',
              cssClass: 'e-toast-danger',
              timeOut: 5000,
            });
          }
          if (err.Status === 404) {
            this.$parent.notificationToasts.push({
              title: 'Error!',
              content: 'Your email is incorrect. Please try again.If you are experiencing any issues, please contact ASCA Tanks at ascatanks@safetycodes.ab.ca or by calling 1-888-413-0099.',
              cssClass: 'e-toast-danger',
              timeOut: 5000,
            });
          }
        }
      } else {
        refEmailVerify.validateEmail();
        this.$parent.notificationToasts.push({
          title: 'Error!', content: 'Please provide valid email id.', cssClass: 'e-toast-danger', timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    tryAgain() {
      this.isEmailSubmitted = false;
    },
  },
};
</script>

<style>
.container-reset-password {
  padding: 16px 12% 16px 12%;
}
</style>
